<div class="external-dashboard">
    <iframe *ngIf="url"
            [src]="url"
            (load)="frameLoaded()"></iframe>

    <div *ngIf="noLinkFound"
         class="alert alert-warning">We could not find any external link to display.
    </div>
</div>
